export const BASE_URL = "https://dummyjson.com/";
export const BASE_URL_PRODUCTION = "https://farmeasy.co.in/API/";
export const TEST_URL = "https://tdka.org/API/";